import type {
  JsonObject,
  GetTeamsWithUserCountResponseBody,
} from '@/app-package';
import axios from 'axios';

export type TeamsWithUserCount = JsonObject<GetTeamsWithUserCountResponseBody>;

const getTeamsWithUserCount = async () => {
  const { data } = await axios.get<TeamsWithUserCount>('/teams_with_count');
  return data;
};

export default getTeamsWithUserCount;
